import debounce from 'lodash/debounce';

import template from './dealers.vhtml';
import { triggerEvent } from '../../scripts/tag-manager';

export default {
	template,
	props: {
		filters: {
			type: Object,
			default: false,
		},
		linkColor: {
			type: String,
			default: null,
		}
	},
	data() {
		return {
			dealers: [],
			linkHover: false,
			isLoading: false,
		};
	},
	watch: {
		filters() {
			if ( this.filters.hasOwnProperty('lat_lng') && this.filters.lat_lng !== null ) {
				this.reload();
			}
		},
		dealers() {
			const dealersCordinates = this.dealers.map( ( dealer ) => {
				return {
					latitude: dealer.googleMapsLat,
					longitude: dealer.googleMapsLng,
					title: dealer.title,
					street: dealer.street,
					city: dealer.city,
					email: dealer.email,
					phone: dealer.phone,
					website: dealer.websiteUrl,
				};
			});
			this.$emit('update-dealers-cordinates', dealersCordinates );
		}
	},
	methods: {
		reload: debounce(function () {
			trackSearch( this.filters );

			this.isLoading = true;
			getItems( this.filters )
				.then( items => {
					if ( items ) {
						this.dealers = items;
					}
				})
				.always(() => this.isLoading = false);
		}, 500),
		openPopup( item ) {
			let popupData = {
				type: '.js-dealer-popup',
				data: item,
			};
			this.$emit( 'update-popup', popupData );
		},
		removeProtocol( url ) {
			return url.replace(/^\/\/|^.*?:(\/\/)?/, '');
		},
	},
};

/**
 * Gets resumes from WP REST API
 *
 * @param {string} post_type
 * @param {string} [search=""]
 * @returns {JQueryPromise<any>}
 */
function getItems( filters ) {
	const params = {
		'search_str': filters.search_str,
		'product_line_id': filters.product_lines_picker_id,
		'lat_lng': filters.lat_lng,
		'lang': window.siteData.language,
	};

	return $.get(`/wp-json/kristensen/v1/dealers`, params);
}

function trackSearch( filters ) {
	const search = filters.search_str;
	triggerEvent( 'searchRetailers', { retailerArea: search } );
}


// WEBPACK FOOTER //
// ./assets/_js/components/dealers/dealers.js